import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import "./DeliveryPartners.scss";
import I18n from "../../../i18n/utils";
import { FAILED, IDLE, NEEDS_REFRESH } from "../../redux/features/constants";
import {
  deliveryPartnerSelector,
  fetchAllBusinessUnitsFCR,
  fetchDeliveryPartners,
} from "../../redux/features/deliveryPartnerSlice";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store/store";
import { Col, Row } from "reactstrap";
import TopNavBar from "../TopNavBar/TopNavBar";
import { BackArrow } from "../Common";
import DeliveryPartnersTable from "./DeliveryPartnersTable/DeliveryPartnersTable";
import CFASpinner from "../Common/CFASpinnner/CFASpinner";

const DeliveryPartners: React.FC = (): JSX.Element => {
  const history = useHistory();
  const [errorMessage, setErrorMessage] = useState<string>("");
  const deliveryPartnersFetchError = useSelector(
    (state: RootState) => state.deliveryPartners.error
  );
  const deliveryPartnersReduxStatus = useSelector(
    (state: RootState) => state.deliveryPartners.deliveryPartnerStatus
  );
  const deliveryPartners = useSelector(deliveryPartnerSelector);
  const dispatch = useDispatch();
  const [displayUpdateModal, setDisplayUpdateModal] = useState<boolean>(false);

  const showUpdateModal = () => {
    setDisplayUpdateModal(true);
  };

  const closeUpdateModal = () => {
    setDisplayUpdateModal(false);
    dispatch(fetchDeliveryPartners());
    // TODO Reset Form Modal on close
    // resetFormModal();
  };

  useEffect(() => {
    if (
      deliveryPartnersReduxStatus === IDLE ||
      deliveryPartnersReduxStatus === NEEDS_REFRESH
    ) {
      dispatch(fetchDeliveryPartners());
      dispatch(fetchAllBusinessUnitsFCR());
    }
    if (deliveryPartnersReduxStatus === FAILED) {
      setErrorMessage(deliveryPartnersFetchError);
    }
  }, [dispatch, deliveryPartnersReduxStatus, deliveryPartnersFetchError]);

  return (
    <>
      <TopNavBar />
      <Col className="DeliveryPartners container">
        <BackArrow />
        <Row>
          <Col xs="7">
            <h3 className="card-title">
              {I18n.t("APP_DELIVERY_PARTNERS_TITLE")}
            </h3>
          </Col>
        </Row>
        {deliveryPartnersReduxStatus &&
        displayUpdateModal &&
        !deliveryPartners.length ? (
          <CFASpinner />
        ) : (
          <>
            <Row>
              <DeliveryPartnersTable
                deliveryPartners={deliveryPartners}
                showUpdateModal={showUpdateModal}
                closeUpdateModal={closeUpdateModal}
                displayUpdateModal={displayUpdateModal}
              />
            </Row>
          </>
        )}
      </Col>
    </>
  );
};

export default DeliveryPartners;
